import React from 'react';
import medical from '../../../assets/medical.jpg';

const Contact = () => {
    return (
        <div className="min-h-screen" style={{ backgroundImage: `url(${medical})`, backgroundSize: 'cover' }}>
            <div className='text-center pb-14 '>
                <p className='text-5xl p-5'>
                    Contact Us
                </p>
                <h1 className='text-3xl font-light'>Stay connected with us</h1>
            </div>
            <div className='grid grid-cols-1 justify-items-center gap-5'>
                <input
                    type='text'
                    placeholder='Email Address'
                    className='input w-full max-w-md'
                />
                <input
                    type='text'
                    placeholder='Subject'
                    className='input w-full max-w-md'
                />
                <textarea
                    className='textarea w-full max-w-md'
                    placeholder='Your message'
                    rows={6}
                ></textarea>
                <button className='btn btn-accent text-white'>Submit</button>
            </div>
        </div>
    );
};

export default Contact;